import React from 'react';
// Quill pen — elegant writing instrument
export const QuillPen = ({
  className = '',
  color = '#6B21A8',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 120" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-120">
    {/* Feather vane */}
    <path d="M12 4 Q8 20 6 40 Q5 60 4 80 L12 78 L20 80 Q19 60 18 40 Q16 20 12 4 Z" fill={color} opacity="0.3" data-id="element-121" />
    {/* Feather barbs */}
    {[0, 1, 2, 3, 4, 5, 6].map(i => <line key={i} x1="12" y1={10 + i * 10} x2="6" y2={12 + i * 10} stroke={color} strokeWidth="0.8" opacity="0.5" data-id="element-122" />)}
    {[0, 1, 2, 3, 4, 5, 6].map(i => <line key={i} x1="12" y1={10 + i * 10} x2="18" y2={12 + i * 10} stroke={color} strokeWidth="0.8" opacity="0.5" data-id="element-123" />)}
    {/* Quill shaft */}
    <line x1="12" y1="78" x2="12" y2="112" stroke="#8B7B9B" strokeWidth="1.4" strokeLinecap="round" data-id="element-124" />
    {/* Nib */}
    <path d="M12 112 L10 118 L12 116 L14 118 Z" fill="#2D1B3D" stroke="#2D1B3D" strokeWidth="0.5" data-id="element-125" />
  </svg>;
// Open journal — book with visible pages
export const OpenJournal = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 80 60" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-126">
    {/* Left page */}
    <path d="M8 12 L38 8 L38 52 L8 48 Z" fill="#FFF9F0" stroke="#6B21A8" strokeWidth="1" data-id="element-127" />
    {/* Right page */}
    <path d="M42 8 L72 12 L72 48 L42 52 Z" fill="#FFF9F0" stroke="#6B21A8" strokeWidth="1" data-id="element-128" />
    {/* Spine shadow */}
    <line x1="40" y1="8" x2="40" y2="52" stroke="#8B7B9B" strokeWidth="2" opacity="0.3" data-id="element-129" />
    {/* Text lines left */}
    {[0, 1, 2, 3, 4].map(i => <line key={i} x1="12" y1={18 + i * 6} x2="34" y2={18 + i * 6} stroke="#8B7B9B" strokeWidth="0.8" opacity="0.4" data-id="element-130" />)}
    {/* Text lines right */}
    {[0, 1, 2, 3, 4].map(i => <line key={i} x1="46" y1={18 + i * 6} x2="68" y2={18 + i * 6} stroke="#8B7B9B" strokeWidth="0.8" opacity="0.4" data-id="element-131" />)}
  </svg>;
// Candle flame — warm light
export const CandleFlame = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 40 100" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-132">
    {/* Flame glow */}
    <ellipse cx="20" cy="18" rx="12" ry="16" fill="#F0D27A" opacity="0.4" className="animate-ember" data-id="element-133" />
    {/* Flame body */}
    <path d="M20 8 Q14 12 14 20 Q14 28 20 32 Q26 28 26 20 Q26 12 20 8 Z" fill="#D4A24C" data-id="element-134" />
    {/* Flame core */}
    <ellipse cx="20" cy="20" rx="4" ry="6" fill="#FFF9F0" data-id="element-135" />
    {/* Wick */}
    <line x1="20" y1="32" x2="20" y2="40" stroke="#2D1B3D" strokeWidth="1.5" data-id="element-136" />
    {/* Candle body */}
    <rect x="14" y="40" width="12" height="50" rx="1" fill="#FAF6EF" stroke="#8B7B9B" strokeWidth="0.8" data-id="element-137" />
    {/* Wax drip */}
    <path d="M16 42 Q14 46 16 50" stroke="#8B7B9B" strokeWidth="1" fill="none" opacity="0.5" data-id="element-138" />
  </svg>;
// Crescent moon — night/shadow work symbol
export const CrescentMoon = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 60 60" className={className} style={style} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-139">
    <path d="M30 8 A18 18 0 0 1 30 52 A22 22 0 0 0 30 8 Z" fill="#6B21A8" opacity="0.7" data-id="element-140" />
    <circle cx="24" cy="22" r="2" fill="#A78BFA" opacity="0.6" data-id="element-141" />
    <circle cx="28" cy="38" r="1.5" fill="#A78BFA" opacity="0.6" data-id="element-142" />
  </svg>;
// Feather — lightness, release
export const Feather = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 32 100" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-143">
    {/* Feather shaft */}
    <line x1="16" y1="10" x2="16" y2="90" stroke="#6B21A8" strokeWidth="2" strokeLinecap="round" data-id="element-144" />
    {/* Vane */}
    <path d="M16 10 Q10 30 8 50 Q7 70 6 90 L16 88 L26 90 Q25 70 24 50 Q22 30 16 10 Z" fill="#A78BFA" opacity="0.3" data-id="element-145" />
    {/* Barbs left */}
    {[0, 1, 2, 3, 4, 5, 6, 7].map(i => <line key={i} x1="16" y1={15 + i * 9} x2="8" y2={17 + i * 9} stroke="#6B21A8" strokeWidth="0.8" opacity="0.6" data-id="element-146" />)}
    {/* Barbs right */}
    {[0, 1, 2, 3, 4, 5, 6, 7].map(i => <line key={i} x1="16" y1={15 + i * 9} x2="24" y2={17 + i * 9} stroke="#6B21A8" strokeWidth="0.8" opacity="0.6" data-id="element-147" />)}
  </svg>;
// Decorative scattered icon group - to be placed in background of sections
export const HealingBackgroundDecor = ({
  className = ''
}: {
  className?: string;
}) => <div className={`absolute inset-0 pointer-events-none overflow-hidden -z-10 ${className}`} aria-hidden="true" data-id="element-148">
    <QuillPen className="absolute top-10 left-[5%] w-4 h-20 opacity-15 animate-float-soft" color="#6B21A8" style={{
    ['--rot' as any]: '15deg',
    transform: 'rotate(15deg)'
  }} data-id="element-149" />
    <Feather className="absolute top-40 right-[8%] w-5 h-24 opacity-15 animate-float-soft" style={{
    ['--rot' as any]: '-25deg',
    transform: 'rotate(-25deg)',
    animationDelay: '1s'
  }} data-id="element-150" />
    <CandleFlame className="absolute bottom-20 left-[8%] w-10 h-24 opacity-20 animate-float-soft" style={{
    animationDelay: '2s'
  }} data-id="element-151" />
    <CrescentMoon className="absolute bottom-32 right-[6%] w-12 h-12 opacity-25 animate-float-soft" style={{
    animationDelay: '0.5s'
  }} data-id="element-152" />
  </div>;